import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';

//Este util retorna el texto del rate de un contenido, ej. +12 años, +16 años, Todos
export const getRateText = code => {
  const translations = useSelector(state => state.translations);
  const ratingClassification = useSelector(
    state => state.metadata?.searches_classificationConversion,
  );
  const getRate = () => {
    if (!ratingClassification) return '';
    const parseRatingClassification = JSON.parse(ratingClassification);
    const ratingKey =
      parseRatingClassification[getRegion()]?.rating_code[code] ||
      parseRatingClassification?.default?.rating_code[code] ||
      '';
    return translations[ratingKey];
  };

  return { getRate };
};
